import React from "react";
import styled from "styled-components";
import { TooltipContainerStyle } from "../Toggletip";
import { GraphLegend } from "./GraphLegend";

type SegmentRatioBarProps = {
    data:{
        value:number,
        color:string,
        valueText?:React.ReactNode,
        legendText?:string,
        tooltip?:React.ReactNode,
    }[],
    heightPx?:number,
    gapPx?:number,
    legendGap?:number,
    legend?:boolean,
    showValueText?:boolean,
    showValueDecimals?:boolean
}
export function SegmentRatioBar(props:SegmentRatioBarProps):JSX.Element
{
    const validSegments = props.data.filter(segment => segment.value > 0);
    const valueTotal = validSegments.reduce((acc, segment) => acc + segment.value, 0);
    
    const barHeight = props.heightPx || 20;

    function getDefaultText(val:number)
    {
        return props.showValueDecimals 
            ? (val/valueTotal*100).toFixed(1) 
            : Math.round(val/valueTotal*100);
    }

    return (
        <div style={{display:'flex', flexDirection:'column', gap:props.legendGap || 4}}>
            <div style={{display:'flex', gap:`${props.gapPx || 2}px`}}>
                {validSegments.map((segment, index) => 
                    <GraphSegment key={index}
                        $color={segment.color}
                        $width={`${segment.value/valueTotal*100}%`}
                        $height={`${barHeight}px`}
                        $showHoverEffect={segment.tooltip !== undefined}>
                        <div style={{overflow:'hidden'}}>
                            {props.showValueText && 
                                (segment.valueText || <span>{`${getDefaultText(segment.value)}%`}</span>)
                            }
                        </div>
                        {segment.tooltip &&
                            <SegmentTooltip width="100px">
                                {segment.tooltip}
                            </SegmentTooltip>
                        }
                        
                    </GraphSegment>
                )}
            </div>
            {props.legend &&
                <GraphLegend data={props.data} showValueDecimals={props.showValueDecimals} />
            }
        </div>
    );
}

const SegmentTooltip = styled.div<{width:string }>`
    visibility: hidden;
    width: ${props => props.width};
    ${TooltipContainerStyle};
    position: absolute;
    z-index: 10;
    bottom: -25px;
    opacity: 0;
    transition: opacity 0.3s;
`;

const GraphSegment = styled.div.attrs<{ $color:string, $width:string, $height:string, $showHoverEffect:boolean }>(props => ({
    style: {
        backgroundColor: props.$color,
        width: props.$width,
        height: props.$height
    }
}))<{ $color:string, $width:string, $height:string, $showHoverEffect:boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position:relative;
    font-size:11px;
    border-radius: 4px;
    
    ${props => props.$showHoverEffect && `
        &:hover {
            outline: 1px solid ${'gray'/*Colors.neutral.palette.shade20*/};
            & ${SegmentTooltip}{
                visibility: visible;   
                opacity: 1;
            }
        }`
    }
`;